<script>
  // import Translations from "./insert-me-to-translate.vue";

  import { getLightboxName } from '../utils'

  const cookieName = 'show_block_lightbox'

  export default {
    props: {
      initPostUpdateHref: {
        type: String,
        required: true,
      },
      initIsUpdatePage: {
        type: Boolean,
        required: true,
      },
      initTcUrl: {
        type: String,
        required: true,
      },
      initSupportEmail: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        lightboxName: null,
        hasCookie: !!this.$cookies.get(cookieName) || false,
        postUpdateHref: this.initPostUpdateHref,
        isUpdatePage: this.initIsUpdatePage,
        translations: {
          warning: gettext('WARNING'),
          similar_ad: gettext(
            'Recently it has been published a similar ad. Edit your ad to publish it.'
          ),
          edit: gettext('Edit'),
          modal_body: interpolate(
            gettext(
              "This ad was blocked from being inserted due to a violation of our <a data-href='%s'>Terms and conditions</a>.<br>For more information, please contact us at: %s"
            ),
            [this.initTcUrl, this.initSupportEmail]
          ),
          close: gettext('Close'),
        },
      }
    },
    computed: {
      shown() {
        return this.$store.getters['ui/lightboxManager/lightboxIsShown'](this.lightboxName)
      },
    },
    watch: {
      shown(isShown) {
        if (isShown) {
          this.removeCookie()
        }
      },
    },
    mounted() {
      this.lightboxName = getLightboxName({ el: this.$el })

      if (!this.hasCookie) {
        this.$store.dispatch('ui/lightboxManager/removeAndHide', this.lightboxName)
      }
    },
    methods: {
      removeCookie() {
        if (this.hasCookie) {
          this.$cookies.remove(cookieName, null, locations.cookie_domain)
        }
      },
      onClose() {
        this.removeCookie()
        this.$store.dispatch('ui/lightboxManager/hide')
      },
      onEdit() {
        if (this.isUpdatePage) {
          this.onClose()
        } else {
          if (this.postUpdateHref) {
            window.location.href = this.postUpdateHref
          } else {
            this.onClose()
          }
        }
      },
    },
  }
</script>

<template>
  <div
    id="lightbox-block"
    ref="lightbox"
    class="modal"
    :class="{ show: shown }"
    tabindex="-1"
    data-backdrop="static"
    :style="shown ? 'display: block;' : 'display: none;'"
    data-testid="lightbox-block-modal"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-lg"
      role="document"
      data-testid="lightbox-block-dialog"
    >
      <div class="modal-content" data-testid="lightbox-block-content">
        <div class="modal-header" data-testid="lightbox-block-header">
          <p
            class="modal-title text-uppercase"
            v-html="translations.warning"
            data-testid="lightbox-block-title"
          ></p>
        </div>
        <div v-if="postUpdateHref || isUpdatePage" data-testid="lightbox-block-edit-mode">
          <div class="modal-body" data-testid="lightbox-block-body">
            <div class="d-flex flex-column bd-highlight mb-3">
              <div class="p-2 bd-highlight">
                <div v-html="translations.similar_ad" data-testid="lightbox-block-similar-ad-text"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center" data-testid="lightbox-block-footer">
            <div>
              <button
                type="button"
                class="btn btn-primary waves-effect waves-light"
                @click="onEdit"
                v-html="translations.edit"
                data-testid="lightbox-block-edit-button"
              ></button>
            </div>
          </div>
        </div>
        <!-- v-else is for the homepage -->
        <div v-else data-testid="lightbox-block-blocked-mode">
          <div class="modal-body" data-testid="lightbox-block-body">
            <div class="d-flex flex-column bd-highlight mb-3">
              <div
                class="p-2 bd-highlight"
                v-html="translations.modal_body"
                data-testid="lightbox-block-message"
              ></div>
            </div>
          </div>
          <div class="modal-footer justify-content-center" data-testid="lightbox-block-footer">
            <button
              type="button"
              class="btn btn-primary waves-effect waves-light"
              @click="onClose"
              v-html="translations.close"
              data-testid="lightbox-block-close-button"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
